export default "<app-widget-meteo></app-widget-meteo>\r\n"